import { useUser } from '../contexts/UserContext'
import { permissionType } from '../utils/constants'

export const useSettingsPermissions = () => {
  const { canAccess, hasAllTabPermissions } = useUser()

  const hasAllSettingsPermissions = hasAllTabPermissions(permissionType.TAB_SETTINGS)

  const canViewSettings = canAccess(permissionType.VIEW_SETTINGS, 0)
  const canSetupSettings = canAccess(permissionType.EDIT_SETUP_SETTINGS, 0)
  const canEditShopSettings = canAccess(permissionType.EDIT_SHOP_SETTINGS, 0)
  const canEditAccountSettings = canAccess(permissionType.EDIT_ACCOUNTS_SETTINGS, 0)
  const canEditInvoiceSettings = canAccess(permissionType.MANAGE_INVOICE, 0)
  const canAccessChannelSettings = canAccess(permissionType.CHANNEL, 0)

  const canAccessPaymentSettings = canAccess(permissionType.PAYMENT_SETTINGS, 0)
  return {
    hasAllSettingsPermissions,
    canViewSettings,
    canSetupSettings,
    canEditShopSettings,
    canEditAccountSettings,
    canEditInvoiceSettings,
    canAccessChannelSettings
  }
}
